export default "__VITE_ASSET__BLb6CD0R__"